'use strict';

import {Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Build, empty, Enumeration, sep} from 'sdv-common';

// https://docs.angularjs.org/api/ng/filter/date
export const fullDate = 'yyyy-MM-dd HH:mm:ss.Z';
export const date_time = 'yyyy-MM-dd HH:mm:ss';

const appMajorVersion = 1;
const appMinorVersion = 0;
const appPatchVersion = 0;
const appVersionType: Enumeration = Build.BETA;

export const retryAfterMillis = 10_000; // 10 sec.

export const serverProtocol = 'https';
export const serverHost = 'stats.sdv291.com';
// export const serverProtocol = 'http';
// export const serverHost = 'localhost:8082';
export const serverAddress = [serverProtocol, sep + sep + serverHost].join(':').toLowerCase();

/**
 * Product version.
 */
export const appVersion: string = [appMajorVersion, appMinorVersion, appPatchVersion].join('.');
/**
 * Full product version.
 */
export const appVersionFull: string = [appVersion, appVersionType.name].join('-');
/**
 * Enable debug mode. Detailed logging.
 */
export const debugging = false;
export const debugRequest = true;

export const info = (message: string, ...args: any[]) => {
  console.log(message, args);
};

export const debug = (message: string, ...args: any[]) => {
  if (!debugging) {
    return;
  }
  console.log(message, args);
};

info('App version: %s', appVersionFull);

/**
 * Injector instance.
 */
let injectorContext;
export const setInjector = (injector: Injector) => {
  injectorContext = injector;
};

export const redirect = (path: string) => {
  _redirect(path, false);
};

export const reload = (path: string) => {
  _redirect(path, true);
};

const _redirect = (path: string, reload: boolean) => {
  if (reload) {
    // injectorContext.get(Router).navigate([path]);
    location.href = path;
  } else {
    injectorContext.get(Router).navigateByUrl(path);
  }
};

/**
 * WebSocket full API helper.
 */
export const wsApi = {
  endpoint: 'ws',
  broker: 'stat',
  internal: {
    action: 'action'
  },
  external: {},
  buildPublisher: (paths: string[], apiVersion: number = 1) => {
    let url = [empty, 'v' + apiVersion, wsApi.broker, ...paths].join(sep);
    if (!url.startsWith(sep)) {
      url = sep + url;
    }
    return url;
  },
  buildSubscriber: (path: string) => {
    let url = [empty, path].join(sep);
    if (!url.startsWith(sep)) {
      url = sep + url;
    }
    return url;
  }
};

export const keys = {
  registration: 'registration',
  project: 'project-id',
  settings: 'settings',
  sid: 'session-id',
  confirmation: 'wait-confirmation'
};

/**
 * Rest full API helper.
 */
export const restApi = {
  endpoint: 'api',
  internal: {
    setting: 'setting',
    menu: {
      top: 'top-menu'
    },
    post: 'post',
    error: 'error',
    login: 'login',
    register: 'register'
  },
  external: {},
  build: (path: string, apiVersion = 1) => {
    return [restApi.endpoint, 'v' + apiVersion, path].join(sep);
  }
};

export const getBrowserName = () => {
  const info = navigator.userAgent;
  if (info.includes('Opera') || info.includes('Opr')) {
    return 'opera';
  }
  if (info.includes('Edg')) {
    return 'edge';
  }
  if (info.includes('Chrome')) {
    return 'chrome';
  }
  if (info.includes('Safari')) {
    return 'safari';
  }
  if (info.includes('Firefox')) {
    return 'firefox';
  }
  return 'unknown';
};

export const getDevice = () => {
  return 'unknown';
};

export const getIp = () => {
  return 'unknown';
};

export const getOs = () => {
  return 'unknown';
};

export const getRandomRgb = () => {
  const num = Math.round(0xffffff * Math.random());
  return {
    red: num >> 16,
    green: num >> 8 & 255,
    blue: num & 255
  };
};
